import React from "react";
import { EditPage } from "@equipedigitalfloripa/ed-cms/components";
import * as especialidadeApi from "../api/especialidades";
import { useSelector } from "react-redux";

const EditEspecialidade = ({ edit }) => {
  const translations = useSelector((state) => state.translations.translations);
  const especialidadesTranslations = translations["system-especialidades"];

  const selectedData = [
    {
      name: "_id",
      type: "hidden",
      title: "Id",
    },
    {
      name: "nome",
      type: "text",
      title: "Nome especialidade",
      validation: {
        required: true,
      },
    },
  ];
  return (
    <EditPage
      selectedData={selectedData}
      addFunction={especialidadeApi.addItem}
      fetchFunction={especialidadeApi.fetchItem}
      editFunction={especialidadeApi.editItem}
      edit={edit}
      url="especialidades"
    />
  );
};

export default EditEspecialidade;
